

class ImageService {
    constructor() {

    }

    isImage = (image:any) => {
        return image.type == undefined || image.type.startsWith('image');      
    }

    buscarPrimeraImagen = (imagenes:any[], appName:string):any => {
        const defaultImage = { url: appName + "/images/banner-bg.jpg", type: 'image/jpeg' };
    
        if (!imagenes || imagenes.length === 0) {
            return defaultImage;
        }

        for (const img of imagenes) {
            if (this.isImage(img)) {
                return img; // Retorna inmediatamente al encontrar la primera imagen válida
            }
        }

        return defaultImage;
          
    }


}


const imageService = new ImageService();

export default imageService;